import intersection from "lodash/intersection";
import { groupTagsByCategory } from "../components/tagSelect/tags";
import type { ListPublicPackagesResponseItem } from "./publicPackagesApi";

interface Tag {
  readonly category: string;
  readonly value: string;
}

export function filterPackages(packages: ListPublicPackagesResponseItem[], tags: Tag[]) {
  if (tags.length === 0) {
    return packages;
  }
  const tagsByCategory = groupTagsByCategory(tags);
  return packages.filter((p) => tagsMatches(p, tagsByCategory));
}

function tagsMatches({ tags }: ListPublicPackagesResponseItem, tagsByCategory: Record<string, string[]>) {
  return Object.entries(tagsByCategory).every(([category, tagsGroup]) => {
    const tagsForCategory = tags.filter((t) => t.category === category).map((t) => t.value);
    return intersection(tagsGroup, tagsForCategory).length > 0;
  });
}
